module.exports = __webpack_public_path__ + "site/img/132.96548abf.jpg";